import { render, staticRenderFns } from "./ActivationButton.vue?vue&type=template&id=51be8cb8"
import script from "./ActivationButton.vue?vue&type=script&lang=js"
export * from "./ActivationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports